import color from 'color'

export function isColorLight(str: string) {
  return color(str).isLight()
}

export function isColorLowContrast(str: string) {
  const other = color(isColorLight(str) ? '#000' : '#fff')
  return color(str).contrast(color(other)) < 10
}